module.exports = __webpack_public_path__ + "static/legend-size-do-67ed70fcb97612997f52319fb40a8e99.png";